import type { Conversation } from '@frontend/features/documents/types';
import { chatApi } from '@frontend/lib/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useConversations() {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['conversations'],
    queryFn: async () => {
      const data = await chatApi.listConversations();
      return data.conversations as Conversation[];
    },
  });

  const createMutation = useMutation({
    mutationFn: (title?: string) => chatApi.createConversation({ title }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
    },
    onError: () => {
      toast.error('Failed to create conversation');
    },
  });

  const deleteMutation = useMutation({
    mutationFn: chatApi.deleteConversation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
      toast.success('Conversation deleted');
    },
    onError: () => {
      toast.error('Failed to delete conversation');
    },
  });

  return {
    conversations: query.data ?? [],
    isLoading: query.isLoading,
    createConversation: createMutation.mutateAsync,
    deleteConversation: deleteMutation.mutate,
    isCreating: createMutation.isPending,
  };
}
